import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const GiftBox = (props: IconProps) => (
  <Icon width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.7128 6.42382H1.92188V16.4238H16.7128V6.42382Z"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2605 0.924872L0.712891 4.46174L1.47663 7.3871L7.7679 5.74466L7.76568 5.73668L10.4187 5.04414L10.4207 5.05212L16.7127 3.40949L15.949 0.484131L14.2605 0.924872Z"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="7.71289" y="6.42383" width="4" height="10" stroke="black" strokeWidth="0.6" />
    <rect
      x="6.88477"
      y="2.85763"
      width="4"
      height="2.99396"
      transform="rotate(-14.091 6.88477 2.85763)"
      stroke="black"
      strokeWidth="0.6"
    />
  </Icon>
);
